export default __webpack_public_path__ + "static/media/closet5-after3-1440w.b3c0cbd8.webp";